import { List } from '@material-ui/core';
import React from 'react';
import { WrappedFieldArrayProps } from 'redux-form';

import ContentListItem from './SectionsSortListItem';

const FormSectionsSortSelector: React.FC<WrappedFieldArrayProps> = ({ fields }) => (
  <List style={{ maxHeight: 560, overflow: 'auto' }}>
    {fields.map((__, index) => {
      const field = fields.get(index);

      if (!field) {
        return null;
      }

      return (
        <ContentListItem
          key={index} // eslint-disable-line react/no-array-index-key
          index={index}
          move={fields.move} // eslint-disable-line @typescript-eslint/unbound-method
          content={{ label: field, index: index + 1 }}
        />
      );
    })}
  </List>
);

export default FormSectionsSortSelector;
